// Shared Nostr constants used by NostrManagement and SocialMediaManagement.

export const DEFAULT_RELAYS = [
  'wss://relay.damus.io',
  'wss://relay.nostr.band',
  'wss://nos.lol',
  'wss://relay.snort.social',
  'wss://nostr.wine'
];

export const PLACEHOLDERS = [
  { key: '{name}', description: 'Business name' },
  { key: '{website}', description: 'Website URL' },
  { key: '{region}', description: 'Service region' },
  { key: '{based_state}', description: 'Based in state' },
  { key: '{categories}', description: 'Business categories' },
  { key: '{abib_status}', description: 'ABIB membership status' },
  { key: '{notes}', description: 'Business notes/description' }
];
